import i18n from 'i18n';
import { apiErrorMessages, APIErrorType } from 'utils/http/index';
import ApiError from 'utils/http/ApiError';
import { formatMessageWithDate } from 'utils/http/format';

export const lookupApiErrorMessage = (error: ApiError) => {
  if (!error.type) {
    return undefined;
  }

  if (error.type === APIErrorType.token_nbf) {
    return {
      description: formatMessageWithDate(error.message),
    };
  }

  if (error.type === APIErrorType.room_not_found) {
    return {
      description: i18n.t('waiting-screens:room.room_not_found'),
    };
  }

  return apiErrorMessages[error.type];
};
